const initialState = {
  status: "invalid",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "USER_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "USER_SUCCESS":
      return {
        ...state,
        status: "success",
        ...action
      };
    case "USER_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};